import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FC, useMemo } from 'react';
import { ReactComponent as FocusedMicrophone } from '@assets/icons/focused_microphone.svg';
import { ReactComponent as FocusedMicrophoneOff } from '@assets/icons/focused_microphone_off.svg';
import { ReactComponent as Microphone } from '@assets/icons/microphone.svg';
import { ReactComponent as MicrophoneOff } from '@assets/icons/microphone_off.svg';

interface FocusableMicrophoneProps {
  onEnterPress: () => void;
  off: boolean;
}

const FocusableMicrophone: FC<FocusableMicrophoneProps> = (props) => {
  const { onEnterPress, off } = props;
  const { ref, focused } = useFocusable({
    onEnterPress
  });

  const Icon = useMemo(() => {
    if (off) {
      return focused ? FocusedMicrophoneOff : MicrophoneOff;
    }

    return focused ? FocusedMicrophone : Microphone;
  }, [focused, off]);

  return (
    <div ref={ref}>
      <Icon />
    </div>
  );
};

export default FocusableMicrophone;
